import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import {AbstractControl, FormControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import { ErrorMessage, UntranslatedErrorMessage } from '@app/layout/rules/template-editor/api/template-editor-node-properties';

@Directive({
  selector: '[appCustomMin][formControlName],[appCustomMin][formControl],[appCustomMin][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CustomMinDirective, multi: true }],
  standalone: false
})
export class CustomMinDirective implements Validator, OnChanges {

  @Input()
  appCustomMin: number;

  @Input()
  minExclusive = false; // dictate if the min value should be excluded

  public static createValidator(min: number, exclusive?): (c: AbstractControl) => ValidationErrors | null {
    const directive = new CustomMinDirective();
    directive.appCustomMin = min;
    if (exclusive != null) {
      directive.minExclusive = exclusive;
    }
    return function (c: AbstractControl) {
      return directive.validate(c);
    };
  }

  @Input()
  customMinErrorMessageFn: (val: number, min: number) => ErrorMessage | UntranslatedErrorMessage = (val: number, min: number) => {
    return {
      messageKey: this.minExclusive ? 'Min Validation Message - exclusive' : 'Min Validation Message',
      parameters: { value: min }
    };
  }

  @Input()
  customMinTransformFn: (v: any) => number = (v: number) => {
    return v;
  }

  private validatorChangeFn: () => void = () => {
  }

  validate(c: AbstractControl): ValidationErrors | null {
    const value = this.customMinTransformFn(c.value);
    if (value == null) {
      return null;
    }

    const min = this.customMinTransformFn(this.appCustomMin);
    const invalid = this.minExclusive ? (value <= min) : (value < min);

    return  invalid
        ? { min: this.customMinErrorMessageFn(c.value, this.appCustomMin) }
        : null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this.validatorChangeFn = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.validatorChangeFn();
  }
}
